import React, { ChangeEvent, useCallback } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FormGroup } from '../../../../../components/form/FormGroup';
import { useUpdateMyBirthdayMutation } from '../../../__generated__/graphql';
import { usePersonalDataQuery } from '../../../__generated__/graphql';
import { Form } from 'react-bootstrap';

const HideMyBirthday: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();

  const { data } = usePersonalDataQuery();

  const [updateMyBirthday, { loading: updateInProgress }] =
    useUpdateMyBirthdayMutation();

  const handleHideMyBirthdayChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.checked;

      updateMyBirthday({
        variables: {
          hideMyBirthday: value,
        },
      });
    },
    [updateMyBirthday],
  );

  return (
    <Col xs={6}>
      <Card>
        <Card.Body>
          <Row className="justify-content-between">
            <Col>
              <Card.Title as="h3">
                {t('personalData.hideMyBirthday')}
              </Card.Title>
            </Col>
          </Row>

          <Row className="justify-content-between">
            <Col>
              <FormGroup>
                <div>
                  <small className="me-2">
                    {t('personalData.hideMyBirthdayDescription')}
                  </small>
                </div>
                <Form.Check
                  type="switch"
                  checked={data?.me?.flair__Hide_My_Birthday__c ?? false}
                  onChange={handleHideMyBirthdayChange}
                  disabled={updateInProgress}
                />
              </FormGroup>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default HideMyBirthday;
